import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import getitemaction from "../../context/action/item/getitemaction";
import { MdDeleteForever } from "react-icons/md";
import createaction from "../../context/action/buy/createaction";
import money_rounding from "../../utils/money_rounding";
import numberbeautify from "../../utils/numberbeautify";

const Buy = () => {
  const { initState, recaller, setrecaller, initDispatch, clear } =
    useContext(GlobalContext);

  const [company_invoice_type, setcompany_invoice_type] = useState("cash");
  const [company_invoice_date, setcompany_invoice_date] = useState();
  const [company_invoice_number, setcompany_invoice_number] = useState();
  const [company_invoice_rmb_price, setcompany_invoice_rmb_price] = useState();
  const [company_invoice_cbi_price, setcompany_invoice_cbi_price] = useState();
  const [company_id, setcompany_id] = useState("");
  const [user_id, setuser_id] = useState();
  const [items, setitems] = useState([]);
  const [text, settext] = useState();

  const [error, seterror] = useState(false);
  const [error1, seterror1] = useState(false);
  const [error2, seterror2] = useState(false);
  const [error3, seterror3] = useState(false);
  const [error4, seterror4] = useState(false);
  const [error5, seterror5] = useState(false);

  const changeval = (index, prop, value) => {};

  return (
    <div className="min-h-screen bg-slate-50 p-6 md:p-8">
      {/* Page Header */}
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">کڕین</h1>
          <p className="text-sm text-slate-400 mt-0.5">ناساندنی پسوڵەی کڕدراو</p>
        </div>
      </div>
      {/* Add New Expense Form */}
      <div className="bg-white border border-slate-100 rounded-xl p-6 mb-6 shadow-sm">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-4 items-end">
        <div className="w-full">
          <label
            htmlFor="cate"
            className={
              error4
                ? "block text-sm font-medium text-red-500 mb-1 text-right"
                : "block text-sm font-medium text-slate-500 mb-1 text-right"
            }
          >
            کۆمپانیای دابینکەر
          </label>
          <select
            id="cate"
            className={
              error4
                ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            }
            value={company_id}
            onChange={(val) => {
              setcompany_id(val.target.value);
            }}
            onFocus={()=>seterror4(false)}
          >
            <option value="">کۆمپانیا</option>
            {initState.company.map((lis) => (
              <option value={lis.company_id}>{lis.company_name}</option>
            ))}
          </select>
        </div>
        <div className="w-full">
          <label
            htmlFor="invoice_type"
            className={"block text-sm font-medium text-slate-500 mb-1 text-right"}
          >
            جۆری وەسڵ
          </label>
          <select
            id="invoice_type"
            className={
              "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            }
            value={company_invoice_type}
            onChange={(val) => setcompany_invoice_type(val.target.value)}
          >
            <option value="cash">کاش</option>
            <option value="loan">قەرز</option>
          </select>
        </div>
        <div className="w-full">
          <label
            className={
              error
                ? "block text-sm font-medium text-red-500 mb-1 text-right"
                : "block text-sm font-medium text-slate-500 mb-1 text-right"
            }
            htmlFor="invoice_date"
          >
            بەرواری وەسڵ
          </label>
          <input
            className={
              error
                ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            }
            id="invoice_date"
            type="date"
            value={company_invoice_date}
            onClick={(val)=>{val.target.select()}}
            onChange={(val) => setcompany_invoice_date(val.target.value)}
            onFocus={() => seterror(false)}
          />
        </div>
        <div className="w-full">
          <label
            className={
              error1
                ? "block text-sm font-medium text-red-500 mb-1 text-right"
                : "block text-sm font-medium text-slate-500 mb-1 text-right"
            }
            htmlFor="invoice_number"
          >
            ژمارەی وەسڵ
          </label>
          <input
            className={
              error1
                ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            }
            id="invoice_number"
            type="text"
            value={company_invoice_number}
            onClick={(val)=>{val.target.select()}}
            onChange={(val) => setcompany_invoice_number(val.target.value)}
            onFocus={() => seterror1(false)}
          />
        </div>
        <div className="w-full">
          <label
            className={
              error2
              ? "block text-sm font-medium text-red-500 mb-1 text-right"
              : "block text-sm font-medium text-slate-500 mb-1 text-right"
            }
            htmlFor="company_invoice_rmb_price"
          >
            نرخی ڕێنمینبی
          </label>
          <input
            className={
              error2
              ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
              : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
              
            }
            id="company_invoice_rmb_price"
            type="number"
            value={company_invoice_rmb_price}
            onClick={(val)=>{val.target.select()}}
            onChange={(val) => setcompany_invoice_rmb_price(val.target.value)}
            onFocus={() => seterror2(false)}
          />
        </div>
        <div className="w-full">
          <label
            className={
              error3
              ? "block text-sm font-medium text-red-500 mb-1 text-right"
              : "block text-sm font-medium text-slate-500 mb-1 text-right"
            }
            htmlFor="company_invoice_cbi_price"
          >
            خەرجی (CBM) بەرامبەر ۱م۳
          </label>
          <input
            className={
              error3
              ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
              : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            }
            id="company_invoice_cbi_price"
            type="number"
            value={company_invoice_cbi_price}
            onClick={(val)=>{val.target.select()}}
            onChange={(val) => setcompany_invoice_cbi_price(val.target.value)}
            onFocus={() => seterror3(false)}
          />
        </div>
      </div>
      </div>
      {/* <div className="w-full sm:w-11/12 bg-gray-400 mx-auto mt-7 rounded-md p-2 sm:p-3">
        <div className="w-full flex flex-col md:flex-row gap-4"> */}
      <div className="bg-gray-400 border border-gray-500 rounded-xl p-6 mb-6 shadow-sm">
        <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-4 items-end">
          <div className="w-full">
            <label
              className={
                "block text-base font-medium text-white mb-1 text-right"
              }
              htmlFor="item_name"
            >
              ناوی کاڵا / کۆد
            </label>
            <input
              className={
                "w-full h-12 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
              }
              id="item_name"
              type="text"
              value={text}
              onClick={(val)=>{val.target.select()}}
              onChange={(val) => settext(val.target.value)}
              onKeyDown={(key) => {
                if (key.key == "Enter") {
                  if (company_id == "" || !company_id) {
                    seterror4(true);
                    return false;
                  }
                  if (company_invoice_date == "" || !company_invoice_date) {
                    seterror(true);
                    return false;
                  }
                  if (company_invoice_number == "" || !company_invoice_number) {
                    seterror1(true);
                    return false;
                  }
                  if (company_invoice_rmb_price < 0 || !company_invoice_rmb_price) {
                    seterror2(true);
                    return false;
                  }
                  if (company_invoice_cbi_price < 0 || !company_invoice_cbi_price) {
                    seterror3(true);
                    return false;
                  }
                  getitemaction(text)(recaller)(setrecaller)(items)(setitems)(
                    settext
                  )(clear);
                }
              }}
            />
          </div>
          <div className="w-full">
            <button
              className="h-12 px-6 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg transition-colors duration-150 w-full"
              onClick={() => {
                if (company_id == "" || !company_id) {
                  seterror4(true);
                  return false;
                }
                if (company_invoice_date == "" || !company_invoice_date) {
                  seterror(true);
                  return false;
                }
                if (company_invoice_number == "" || !company_invoice_number) {
                  seterror1(true);
                  return false;
                }
                if (company_invoice_rmb_price < 0 || !company_invoice_rmb_price) {
                  seterror2(true);
                  return false;
                }
                if (company_invoice_cbi_price < 0 || !company_invoice_cbi_price) {
                  seterror3(true);
                  return false;
                }
                getitemaction(text)(recaller)(setrecaller)(items)(setitems)(
                  settext
                )(clear);
              }}
            >
              ئایتم
            </button>
          </div>
        </div>
      </div>
      {items.length > 0 ? (
        <>
        <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-slate-50 border-b border-slate-100">
                      <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                        ناوی کاڵا
                      </th>
                      <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                        کۆد
                      </th>
                      <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                        نرخی کڕین
                      </th>
                      <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                        بڕ - کۆ
                      </th>
                      <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                        بڕی (CBM) م۳
                      </th>
                      <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                        نرخ - تاک
                      </th>
                      <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                        نرخ - کۆ
                      </th>
                      <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                        کۆی نرخ
                      </th>
                      <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                        نرخی فرۆش
                      </th>
                      <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                        ڕەشکردنەوە
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-50">
                    {items.map((lis, index) => (
                      <tr key={index} className="hover:bg-slate-50 transition-colors duration-100 cursor-pointer">
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                          {lis.item_name}
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                          {lis.item_barcode}
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                          <input
                            className={
                              "w-[120px] lg:w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                            }
                            id="grid-last-name"
                            type="number"
                            onClick={(val)=>{val.target.select()}}
                            value={lis.company_invoice_item_price}
                            onChange={(val) => {
                              setitems(
                                items.map((lis, indexx) =>
                                  index == indexx
                                    ? {
                                        item_id: lis.item_id,
                                        item_name: lis.item_name,
                                        item_barcode: lis.item_barcode,
                                        item_price: lis.item_price,
                                        item_base_price:val.target.value,
                                        company_invoice_item_qty:
                                          lis.company_invoice_item_qty,
                                        company_invoice_item_price:
                                          val.target.value,
                                        company_invoice_item_cbi_m3:
                                          lis.company_invoice_item_cbi_m3,
                                        company_invoice_item_cbi_total_price:
                                          lis.company_invoice_item_cbi_total_price,
                                        item_unit_one_of_many:
                                          lis.item_unit_one_of_many
                                      }
                                    : lis
                                )
                              );
                            }}
                          />
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                          <input
                            className={
                              "w-[120px] lg:w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                            }
                            id="grid-last-name"
                            type="number"
                            onClick={(val)=>{val.target.select()}}
                            value={lis.company_invoice_item_qty}
                            onChange={(val) => {
                              setitems(
                                items.map((lis, indexx) =>
                                  index == indexx
                                    ? {
                                        item_id: lis.item_id,
                                        item_name: lis.item_name,
                                        item_barcode: lis.item_barcode,
                                        item_price: lis.item_price,
                                        item_base_price:lis.item_base_price,
                                        company_invoice_item_qty:
                                          val.target.value,
                                        company_invoice_item_price:
                                          lis.company_invoice_item_price,
                                        company_invoice_item_cbi_m3:
                                          lis.company_invoice_item_cbi_m3,
                                        company_invoice_item_cbi_total_price:
                                          lis.company_invoice_item_cbi_total_price,
                                        item_unit_one_of_many:
                                          lis.item_unit_one_of_many
                                      }
                                    : lis
                                )
                              );
                            }}
                          />
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                          <input
                            className={
                              "w-[120px] lg:w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                            }
                            id="grid-last-name"
                            type="number"
                            onClick={(val)=>{val.target.select()}}
                            value={lis.company_invoice_item_cbi_m3}
                            onChange={(val) => {
                              setitems(
                                items.map((lis, indexx) =>
                                  index == indexx
                                    ? {
                                        item_id: lis.item_id,
                                        item_name: lis.item_name,
                                        item_barcode: lis.item_barcode,
                                        item_price: lis.item_price,
                                        item_base_price:lis.item_base_price,
                                        company_invoice_item_qty:
                                          lis.company_invoice_item_qty,
                                        company_invoice_item_price:
                                          lis.company_invoice_item_price,
                                        company_invoice_item_cbi_m3:
                                          val.target.value,
                                        company_invoice_item_cbi_total_price:
                                          money_rounding(Number(val.target.value)*Number(company_invoice_cbi_price)),
                                        item_unit_one_of_many:
                                          lis.item_unit_one_of_many
                                      }
                                    : lis
                                )
                              );
                            }}
                          />
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                          {numberbeautify(money_rounding((((Number(lis?.company_invoice_item_price)/Number(company_invoice_rmb_price)))+(Number(lis.company_invoice_item_cbi_m3)*Number(company_invoice_cbi_price)))/Number(lis?.item_unit_one_of_many)))}
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                          {numberbeautify(money_rounding(((Number(lis?.company_invoice_item_price)/Number(company_invoice_rmb_price)))+(Number(lis.company_invoice_item_cbi_m3)*Number(company_invoice_cbi_price))))}
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                          {numberbeautify(money_rounding((Number(lis?.company_invoice_item_price)/Number(company_invoice_rmb_price)+Number(lis.company_invoice_item_cbi_m3)*Number(company_invoice_cbi_price))*Number(lis?.company_invoice_item_qty)))}
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                          <input
                            className={
                              "w-[120px] lg:w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                            }
                            id="grid-last-name"
                            type="number"
                            onClick={(val)=>{val.target.select()}}
                            value={lis.item_price}
                            onChange={(val) => {
                              setitems(
                                items.map((lis, indexx) =>
                                  index == indexx
                                    ? {
                                        item_id: lis.item_id,
                                        item_name: lis.item_name,
                                        item_barcode: lis.item_barcode,
                                        item_price: val.target.value,
                                        item_base_price:lis.item_base_price,
                                        company_invoice_item_qty:
                                          lis.company_invoice_item_qty,
                                        company_invoice_item_price:
                                          lis.company_invoice_item_price,
                                        company_invoice_item_cbi_m3:
                                          lis.company_invoice_item_cbi_m3,
                                        company_invoice_item_cbi_total_price:
                                          lis.company_invoice_item_cbi_total_price,
                                        item_unit_one_of_many:
                                          lis.item_unit_one_of_many
                                      }
                                    : lis
                                )
                              );
                            }}
                          />
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                          <p className="text-gray-900 whitespace-no-wrap">
                            <MdDeleteForever
                              size={28}
                              color="#e74c3c"
                              className="cursor-pointer"
                              onClick={() => {
                                setitems(
                                  items.filter(
                                    (list) => list.item_id != lis.item_id
                                  )
                                );
                              }}
                            />
                          </p>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
        </div>
        <div className="w-full md:w-1/6 mt-4">
                  <button
                    className={
                      items.length > 0
                        ? "h-12 px-6 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg transition-colors duration-150 w-full"
                        : "h-12 px-6 bg-indigo-300 hover:bg-indigo-400 text-white text-sm font-semibold rounded-lg transition-colors duration-150 w-full"
                    }
                    disabled={items.length > 0 ? false : true}
                    onClick={() => {
                      if (company_id == "" || !company_id) {
                        seterror4(true);
                        return false;
                      }
                      if (company_invoice_date == "" || !company_invoice_date) {
                        seterror(true);
                        return false;
                      }
                      if (company_invoice_number == "" || !company_invoice_number) {
                        seterror1(true);
                        return false;
                      }
                      if (company_invoice_rmb_price < 0 || !company_invoice_rmb_price) {
                        seterror2(true);
                        return false;
                      }
                      if (company_invoice_cbi_price < 0 || !company_invoice_cbi_price) {
                        seterror3(true);
                        return false;
                      }
                      var temp_item=[];
                      for(var i=0;i<items.length;i++){
                        var temp_a={
                          item_id: items[i].item_id,
                          item_name: items[i].item_name,
                          item_barcode: items[i].item_barcode,
                          item_price: items[i].item_price,
                          item_base_price: items[i].item_base_price,
                          // company_invoice_item_qty: items[i].company_invoice_item_qty,
                          company_invoice_item_qty: (Number(items[i].company_invoice_item_qty)*(items[i].item_unit_one_of_many)),
                          company_invoice_item_price: (Number(items[i]?.company_invoice_item_price)/Number(company_invoice_rmb_price))+(Number(items[i]?.company_invoice_item_cbi_m3)*Number(company_invoice_cbi_price)),
                          company_invoice_item_cbi_m3: items[i].company_invoice_item_cbi_m3,
                          company_invoice_item_cbi_total_price: items[i].company_invoice_item_cbi_total_price,
                          item_unit_one_of_many: items[i].item_unit_one_of_many,
                        }
                        temp_item.push(temp_a);
                      }
                      
                      createaction(
                        company_invoice_type,
                        company_invoice_date,
                        "",
                        company_invoice_number,
                        company_id,
                        initState.token.user_id,
                        company_invoice_rmb_price,
                        company_invoice_cbi_price,
                        temp_item
                      )(recaller)(setrecaller)(initDispatch)(clear);
                    }}
                  >
                    زیادکردنی وەسڵ
                  </button>
              </div>
        </>
      ) : null}
    </div>
  );
};

export default Buy;
